import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockAlignSchema,
  TopolBlockSchema,
  TopolColorSchema,
  TopolColorBearingSchema,
} from "../commonSchema";

const defaults = {
  align: "center" as const,
  "background-color": "#F5A623",
  color: "#ffffff",
  "border-radius": "3px",
  "font-size": "13px",
  padding: "20px 20px 20px 20px",
  "inner-padding": "10px 20px 10px 20px",
  href: "",
  "font-family": "Helvetica, Arial, sans-serif",
  containerWidth: 600,
};

export const TopolButtonBlockAttributesBasicSchema = z.object({
  align: TopolBlockAlignSchema,
  "background-color": TopolColorSchema.catch("#F5A623"),
  color: TopolColorSchema.catch("#ffffff"),
  "border-radius": z.string(),
  "font-size": z.string(),
  padding: z.string(),
  "inner-padding": z.string(),
  href: z.string().trim(),
  "font-family": z.string(),
  containerWidth: z.number(),
  width: z.union([z.string(), z.number()]).optional(),
  border: TopolColorBearingSchema.optional(),
  "line-height": z.union([z.string(), z.number()]).optional(),
  "css-class": TopolBlockCssClassSchema.optional(),
  "font-weight": z.string().optional(),
  "font-style": z.string().optional(),
  "text-transform": z.string().optional(),
  "text-decoration": z.string().optional(),
  "letter-spacing": z.string().optional(),
  "container-background-color": TopolColorSchema.optional().catch(undefined),
  gradient: TopolColorBearingSchema.optional(),
  "text-align": TopolBlockAlignSchema.optional(),
});

export const TopolButtonBlockAttributesSchema =
  TopolButtonBlockAttributesBasicSchema.extend({
    align: TopolBlockAlignSchema.catch(defaults.align),
    "background-color": TopolColorSchema.catch(defaults["background-color"]),
    color: TopolColorSchema.catch(defaults.color),
    "border-radius": z.string().catch(defaults["border-radius"]),
    "font-size": z.string().catch(defaults["font-size"]),
    padding: z.string().catch(defaults.padding),
    "inner-padding": z.string().catch(defaults["inner-padding"]),
    href: z.string().trim().catch(defaults.href),
    "font-family": z.string().catch(defaults["font-family"]),
    containerWidth: z.number().catch(defaults.containerWidth),
  });

export const TopolButtonBlockStyleAttributesSchema =
  TopolButtonBlockAttributesSchema.omit({
    href: true,
    containerWidth: true,
  });

export type TopolButtonBlockAttributes = z.infer<
  typeof TopolButtonBlockAttributesSchema
>;

export const TopolButtonBlockHoverAttributesSchema = z.object({
  "background-color": TopolColorSchema.optional().catch(undefined),
  color: TopolColorSchema.optional().catch(undefined),
  border: TopolColorBearingSchema.optional(),
  gradient: TopolColorBearingSchema.optional(),
});

export const TopolButtonBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-button"),
  attributes: TopolButtonBlockAttributesSchema.catch(defaults),
  content: z.string().catch(""),
  hover: TopolButtonBlockHoverAttributesSchema.optional().catch(undefined),
});

export type TopolButtonBlock = z.infer<typeof TopolButtonBlockSchema>;
